import { Api, router } from "@/@core";
import { RestWorkerContactData } from "./interfaces/worker/RestWorker";

interface MaybeValid<T> {
  errorCode: number;
  errorMessage: string | null;
  result: T;
  valid: boolean;
}

// 'api/fsend' is used because we're reusing the gateway code (be.isocial.fonds.gateway)
// TODO?: ideally, this route should be renamed so that it's not linked to a client
const api = new Api("fsend");

export class FsegWorkerRestService {
  public static async editContactData(
    ssin: string,
    contactData: RestWorkerContactData
  ): Promise<RestWorkerContactData> {
    const response = await api.put<MaybeValid<RestWorkerContactData>>(`workers.svc/${ssin}`, contactData);
    if (response?.data?.valid) {
      return response.data.result;
    } else {
      throw new Error(`${router.app.$t("fseg.error.editWorker")}`);
    }
  }
}
